import type { HelpFile } from '../../types/help'
import { ButtonSpinnerTestIds } from '../../../testids/ButtonSpinnerTestIds'

export const buttonSpinnerHelp: HelpFile = {
  docPage: '/docs/help-system/components',
  texts: {
    [ButtonSpinnerTestIds.buttonSpinner]: null,
  },
}
